/* tslint:disable:variable-name */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { DocumentTypeEnterprise } from '../class/DocumentTypeEnterprise';
import { DocumentEntity } from "../class/DocumentEntity";
import { Field } from 'src/app/shared/models/field.model';
import { TemplateFile } from 'src/app/shared/models/template-file.model';
import { DocumentTemplate } from 'src/app/shared/models/document-template.model';
import { FormData } from 'src/app/shared/models/form-data.model';
import { EnterpriseService } from './enterprise.service';
import { ContractService } from './contract.service';

@Injectable({
  providedIn: 'root'
})
export class CreateContractService {
  constructor(
    private enterpriseService: EnterpriseService,
    private contractService: ContractService
  ) {
  }

  public recordsPartySign: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public recordsUserPerformSign: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public recordsInternalUsers: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public pdfSrc: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public fileUpload: BehaviorSubject<File> = new BehaviorSubject<File>(null);
  public selectedTemplate: BehaviorSubject<DocumentTypeEnterprise> = new BehaviorSubject<DocumentTypeEnterprise>(null);
  public document: BehaviorSubject<DocumentEntity> = new BehaviorSubject<DocumentEntity>(null);
  public currentStep: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public dataReferenceContract: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public dataDocumentParentNewUploadContractAttachments: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public isSubmitData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isInvalidSetPartyFlow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isValidateData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isConfirmBCT: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public contractCode: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public isRecordsPartySignValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isGeneralInfoValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public createContractType: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public isOnAutoNumber: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public configAutoNumber: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public selectedServiceType: BehaviorSubject<string> = new BehaviorSubject<any>(null);
  public exampleContractCodeAutoNumber: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public refreshContractCode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isChangeFile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isChangeTypeDocAndTemp: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);//doi giua file va mau
  public backView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public fieldData: Field[] = null;
  public documentFileTemplate: BehaviorSubject<TemplateFile> = new BehaviorSubject<TemplateFile>(null);
  public documentTemplate: DocumentTemplate = null;

  public isExportData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public fileExport: File = null;
  public isSuccessStep2: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public isDuplicateCode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isSignatureConfiguration: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public tableModel: FormData = null;
  public saveDataTable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public cacheRecordParty: any;
  public cacheRecordInternalUser: any;
  public isBack: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public checkFootNote: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isDirty: boolean = false;
  public isShowPopupPdf: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public changeFileOutput: boolean = false;
  public signatureData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public listDataCustomerApproveResize: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public signatureDataSign: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public cacheCustomerForSignature: any;
  public saveRecordParty: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public signPositions: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public contractCodePositions: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public listSignatureTable: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public isInvalidInfo: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public codeIsDuplicate = new BehaviorSubject<boolean>(false);
  public isValidForm: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public isInvalidFieldTypeContract: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isRenderNewFile: boolean = false;
  public isNewFileTag: boolean = false;
  public procedureId: any;
  public procedureType: any;
  public fileUploadSrc: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public fileUploadArray: BehaviorSubject<File[]> = new BehaviorSubject<File[]>([]);
  public mainContractAttactment: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public maxSizeSystem: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public maxPerMainFile: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public maxPerAttachFile: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public biggerThan10MBFileSize: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public isUpdateDocument : boolean=false;
  public serviceTypes:any[]=null;
  public fileSizeUp: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public isBuyContract10Mb: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isBuyContract1Mb: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public configSizeApprove: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public configPageSign: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public configNumberPosition: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public infoFile: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public infoFileTemplate: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public isCopy: boolean = false;
  public key: string = null;
  public signatureResponse = null;
  public currentTotalcapacityMainAttachments: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public fileFormTemplate: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public pdfSrcForm: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public renderFileOnce: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public recordsSharePartner: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public contractTerminations: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  /**
   * Cache thong tin enterprise mac dinh (GET /enterprises/{id}) cho flow add-document:
   * step 0 mount 2 instance record-party-sign (check=1 va check=2) cung goi api nay -> dung lai 1 response.
   * resetData() (chay khi moi vao flow) clear cache de lay du lieu moi.
   */
  private cachedDefaultEnterprise$: Observable<any>;
  private cachedDefaultEnterpriseKey: string;

  getDefaultEnterprise(enterpriseId: string): Observable<any> {
    if (!this.cachedDefaultEnterprise$ || this.cachedDefaultEnterpriseKey !== enterpriseId) {
      this.cachedDefaultEnterpriseKey = enterpriseId;
      this.cachedDefaultEnterprise$ = this.enterpriseService.getEnterpriseByIDSilently(enterpriseId).pipe(
        shareReplay(1),
        // shareReplay cache ca error: neu request dau fail thi clear de lan sau fetch lai
        catchError(err => {
          this.invalidateDefaultEnterprise();
          return throwError(err);
        })
      );
    }
    return this.cachedDefaultEnterprise$;
  }

  invalidateDefaultEnterprise() {
    this.cachedDefaultEnterprise$ = null;
    this.cachedDefaultEnterpriseKey = null;
  }

  /**
   * Cache GET /enterprises/enterprise-by-service cho flow add-document:
   * add-document component goi khi init, upload-multi-file-attachments goi lai khi chon file
   * -> dung lai 1 response. resetData() (chay khi moi vao flow) clear cache de lay du lieu moi.
   */
  private cachedEnterpriseByService$: Observable<any>;

  getEnterpriseByService(): Observable<any> {
    if (!this.cachedEnterpriseByService$) {
      this.cachedEnterpriseByService$ = this.contractService.getDataCountNumberDocumentOfEnterpriseByService().pipe(
        shareReplay(1),
        // shareReplay cache ca error: neu request dau fail thi clear de lan sau fetch lai
        catchError(err => {
          this.invalidateEnterpriseByService();
          return throwError(err);
        })
      );
    }
    return this.cachedEnterpriseByService$;
  }

  invalidateEnterpriseByService() {
    this.cachedEnterpriseByService$ = null;
  }

  setRecordsPartySign(value) {
    this.recordsPartySign.next(value);
  }

  getRecordsPartySign() {
    return this.recordsPartySign.asObservable();
  }

  hasCurrentCustomerFootnote(signatures: any[]): boolean {
    const footnote = this.signatureDataSign.getValue();
    if (!this.checkFootNote.getValue() || !Array.isArray(footnote) || !footnote.length) {
      return false;
    }
    const footnoteParties = footnote.filter(party => party && !party.isCreatedSide);
    const currentParties = (this.recordsPartySign.getValue() || [])
      .filter(party => party && !party.isCreatedSide);
    if (footnoteParties.length !== currentParties.length || footnoteParties.some(party => {
      const current = currentParties.find(item => item.customerId === party.customerId);
      return !current || (Number(current.order) || 0) !== (Number(party.order) || 0);
    })) {
      return false;
    }
    const assignedIds = footnoteParties.reduce((ids, party) => ids.concat((party.customerApproves || [])
      .filter(person => person.signatureId != null).map(person => String(person.signatureId))), [] as string[]);
    return !assignedIds.length || assignedIds.every(id => (signatures || []).some(item => {
      const signature = item.signature || item;
      return signature && String(signature.signatureId) === id;
    }));
  }

  getCustomerFootnoteParticipants(signatures?: any[]): any[] {
    const footnote = this.signatureDataSign.getValue();
    if (this.hasCurrentCustomerFootnote(signatures || this.signatureData.getValue() || [])) {
      return footnote.filter(party => party && !party.isCreatedSide)
        .reduce((people, party) => people.concat((party.customerApproves || [])
          .filter(person => person && person.customerId &&
            (String(person.role) === '1' || String(person.role) === '2' || String(person.role) === '7'))), []);
    }

    const parties = (this.recordsPartySign.getValue() || [])
      .filter(party => party && !party.isCreatedSide && party.customerId)
      .sort((a, b) => (Number(a.order) || 0) - (Number(b.order) || 0));
    return parties.reduce((people, party) => {
      const approvers = (party.isSetupSignFlow ? party.customerApproves || [] : [])
        .filter(person => person && person.customerId &&
          (!person.role || String(person.role) === '2' || String(person.role) === '7'))
        .map(person => ({ ...person, role: person.role || 2 }));
      return people.concat(approvers, { ...party, role: party.role || 1 });
    }, []);
  }

  setContractCode(value) {
    this.contractCode.next(value);
  }

  getContractCode() {
    return this.contractCode.asObservable();
  }

  resetData() {
    this.isInvalidFieldTypeContract.next(false);
    this.currentStep.next(0);
    this.pdfSrc.next(null);
    this.selectedTemplate.next(null);
    this.recordsPartySign.next([]);
    this.recordsInternalUsers.next([]);
    this.recordsUserPerformSign.next([]);
    this.document.next(null);
    this.isSubmitData.next(false);
    this.isValidateData.next(false);
    this.isRecordsPartySignValid.next(false);
    this.isGeneralInfoValid.next(false);
    this.fileUpload.next(null);
    this.createContractType.next(null);
    this.fieldData = null;
    this.documentFileTemplate.next(null);
    this.isExportData.next(false);
    this.fileExport = null;
    this.isSuccessStep2.next(false);
    this.isDuplicateCode.next(false);
    this.documentTemplate = null;
    this.tableModel = null;
    this.saveDataTable.next(false);
    this.cacheRecordParty = null;
    this.cacheRecordInternalUser = null;
    this.changeFileOutput = false;
    this.isDirty = false;
    this.signPositions.next([]);
    this.isInvalidInfo.next(false);
    this.signatureData.next(null);
    this.cacheCustomerForSignature = null;
    this.saveRecordParty.next(false);
    this.isValidForm.next(true);
    // this.isRenderNewFile = false;
    this.isNewFileTag = false;
    this.fileUploadArray.next([]);
    this.mainContractAttactment.next([]);
    this.fileUploadSrc.next([]);
    this.procedureId = null;
    this.procedureType = null;
    this.isCopy = false;
    // this.key = null;
    this.signatureResponse = null;
    this.isSignatureConfiguration.next(null);
    this.isOnAutoNumber.next(false);
    this.refreshContractCode.next(false);
    this.configAutoNumber.next('');
    this.selectedServiceType.next(null);
    this.exampleContractCodeAutoNumber.next('');
    this.contractCodePositions.next([]);
    this.listSignatureTable.next([]);
    this.isChangeTypeDocAndTemp.next(false);
    this.isUpdateDocument=false;
    this.serviceTypes=null;
    this.maxSizeSystem.next(0);
    this.maxPerMainFile.next(0);
    this.maxPerAttachFile.next(0);
    this.biggerThan10MBFileSize.next(null);
    this.fileSizeUp.next(null);
    this.isBuyContract10Mb.next(false);
    this.isBuyContract1Mb.next(false);
    this.configSizeApprove.next(null);
    this.configPageSign.next(null);
    this.configNumberPosition.next(null);
    this.infoFile.next(null);
    this.infoFileTemplate.next(null)
    this.fileFormTemplate.next(null)
    this.pdfSrcForm.next(null)
    this.renderFileOnce.next(0)
    this.recordsSharePartner.next([])
    this.contractTerminations.next([])
    this.invalidateDefaultEnterprise();
    this.invalidateEnterpriseByService();
  }

  public validateErrorSetUser(model?) {
    // khi chủ thể không có chủ thể đang đăng nhập thì không kiểm tra user nữa
    const checkCurrentEnterprise = this.recordsPartySign.value.filter(item => item.isCreatedSide === true);
    if (checkCurrentEnterprise.length === 0) {
      // this.isValidNoUserExist = false;
      // this.subscribeIsValidNoUserExist.next(false);
      return false;
    }

    // Kiểm tra trong list ko chua User nào?null
    if (this.recordsUserPerformSign.getValue().length === 0) {
      // this.isValidNoUserExist = true;
      // this.subscribeIsValidNoUserExist.next(true);
      return true;
    } else {
      // this.isValidNoUserExist = false;
      // this.subscribeIsValidNoUserExist.next(false);
    }
    return false;
  }

  validateData() {
    // validate document
    // ds chủ thể
    // ds người dùng
    this.isSubmitData.next(true);
  }

  exportFile() {
    if (!this.isExportData.getValue()) {
      this.isExportData.next(true);
    }
  }

  generateUUID() { // Public Domain/MIT
    let d = new Date().getTime();//Timestamp
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }
}
